module.exports = __webpack_public_path__ + "static/media/icon_extension_jpg.d88fdea3.svg";